module.exports = __webpack_public_path__ + "static/media/biba.843a4da5.png";